export default __webpack_public_path__ + "static/media/Logo-blanco.733fe5b7.png";